import React, { useContext, useCallback, useState } from "react";
import { StyleSheet, View, Text }                   from "react-native";
import Row                                          from "../../../layouts/Row";
import Col                                          from "../../../layouts/Col";
import Heading                                      from "../../Heading";
import palette                                      from "~/styles/palette";
import ExpandableCard                               from "../../ExpandableCard/index.web";
import dayjs                                        from "../../../helpers/day";
import { getLabelForStatus }                        from "../../../helpers/jobs";
import ParticipantContext                           from "../../../contexts/ParticipantContext";

export default function ParticipantSchedule() {
  const { customer, getCustomer } = useContext(ParticipantContext);
  const { jobs = [] } = customer || {};

  if (!customer) return null;

  return (
    <ExpandableCard
      title="Schedule"
      icon="calendar"
      badge={jobs.length}
      onOpen={getCustomer}
    >
      {jobs.map((job, x) => {
        return <ScheduleItem key={x} item={job} />;
      })}
    </ExpandableCard>
  );
}

const ScheduleItem = ({ item }) => {
  const statusLabel = getLabelForStatus(item.status);

  return (
    <View style={[styles.participant_details__schedule__item_container]}>
      <Row pl={8} pr={8}>
        <Col leftCenter>
          <Heading size={5} ml={0}>
            {item.job_type}
          </Heading>
          <Text
            numberOfLines={1}
            style={[styles.participant_details__schedule__item_day]}
          >
            {dayjs(item.start_time).format("MMM Do")} &middot;{" "}
            {dayjs(item.start_time).local().format("h:mm A")}
          </Text>
        </Col>
        <Col rightCenter>
          <View
            style={{
              backgroundColor: statusLabel.color,
              paddingHorizontal: 12,
              paddingVertical: 4,
              borderRadius: 5,
            }}
          >
            <Text style={[styles.participant_details__schedule__item_status]}>
              {statusLabel.label}
            </Text>
          </View>
        </Col>
      </Row>
    </View>
  );
};

const styles = StyleSheet.create({
  participant_details__schedule__container: {
    fontWeight: "500",
    color: palette.grey,
    paddingHorizontal: 16,
    borderColor: palette.lighter_grey,
    borderBottomWidth: 1,
    overflow: "hidden",
    transitionDuration: "150ms",
    transitionProperty: "height",
    transitionTimingFunction: "ease-out",
    height: 320,
  },
  participant_details__schedule__item_container: {
    height: 70,
    justifyContent: "center",
  },
  participant_details__schedule__item_name: {
    fontSize: 14,
  },
  participant_details__schedule__item_day: {
    fontSize: 16,
    fontWeight: "600",
    paddingHorizontal: 4,
    color: palette.primary_light,
  },
  participant_details__schedule__item_status: {
    color: palette.white,
    fontWeight: "500",
  },
});
